/**
 * parameter.js
 */

define(
        'parameter',
        ['js-base64', 'lib'],
        function (Base64, lib) {
            "use strict";
            /**
             * Applique un base64_decode() sur la valeur passé en paramettre
             * uniquement si elle a été encodé automatiquement avec le
             * prefix __BASE64ENCODED__
             * @param {type} str
             * @returns {string}
             */
            function decodeParam(str)
            {
                if (!lib.empty(str)) {
                    var b64Flag = '__BASE64ENCODED__';
                    str = '' + str; // Transformation en chaine de caractere
                    if (str.substr(0, b64Flag.length) === b64Flag) {
                        str = Base64.decode(str.substr(b64Flag.length));
                    }
                }
                return str;
            }

            /**
             * Applique un base64_encode() sur la valeur passé en paramettre
             * @param {string} data Donnée à encrypter
             * @returns {String} données cryptées Base64
             */
            function encodeParam(data)
            {
                if (data) {
                    var b64Flag = '__BASE64ENCODED__';
                    data = '' + data; // Transformation en chaine de caractere
                    if (data.substr(0, b64Flag.length) !== b64Flag) {
                        data = '__BASE64ENCODED__' + Base64.encodeURI('' + data);
                    }
                }

                return data;
            }

            //    exposed public method
            return {
                decodeParam: decodeParam,
                encodeParam: encodeParam
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
